import {useState} from 'react';
import {useHistory} from 'react-router';
import actions from '../api/ownDeclaration';
import {validateLength} from '../utilis/validateLength';
import UIButton from '../components/UICommon/UIButton';
import UICardHeader from '../components/UICommon/UICardHeader';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';
import UIModal from '../components/UICommon/UIModal';
import UIStackedInput from '../components/UICommon/UIStackedInput';
import OwnDeclarationAddInputs from '../components/OwnDeclarationPage/OwnDeclarationAddInputs';

const AddBooleanQuestionPage: React.FC = () => {
  const [questionName, setQuestionName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [formValues, setFormValues] = useState([{name: '', text: '', nameError: '', textError: ''}]);
  const [questionErrors, setQuestionErrors] = useState({
    questionName: '',
  });
  const history = useHistory();

  // eslint-disable-next-line max-len
  const desc = 'Här kan du skapa ett fält i hälsodeklarationen där ja- och nej påståenden besvaras av kunden. Välj vilken rubrik du vill ha och sedan och fyll den text som kommer visas för kund som väljer ja- eller nej.';

  const handleChange = (i: any, e: any) => {
    const newFormValues: any = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    if (e.target.value.length > 1024 && e.target.name === 'name') {
      newFormValues[i].nameError = 'Se till att detta fält inte har mer än 1024 tecken.';
    }
    if (e.target.value.length > 1024 && e.target.name === 'text') {
      newFormValues[i].textError = 'Se till att detta fält inte har mer än 1024 tecken.';
    }
    setFormValues(newFormValues);
  };

  const addFormFields = () => {
    setFormValues([...formValues, {name: '', text: '', nameError: '', textError: ''}]);
  };

  const removeFormFields = (i: any) => {
    const newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  const onSubmit = () => {
    const tmpContent = [] as any;
    const tmpFormValues = [] as any;
    const tmpErrors = {
      questionName: validateLength(questionName),
    };
    setQuestionErrors(tmpErrors);
    let hasErrors = Object.values(tmpErrors).some((error) => error !== '');
    formValues.forEach((element: any, idx: number) => {
      if (element.nameError && element.nameError.length > 0) {
        hasErrors = true;
      }
      if (element.textError && element.textError.length > 0) {
        hasErrors = true;
      }
      tmpFormValues.push({
        name: element.name,
        nameError: validateLength(element.name),
        text: element.text,
        textError: validateLength(element.text),
      });
      tmpContent.push({
        'name': element.name,
        'text': element.text,
        'order': idx,
      });
    });
    setFormValues(tmpFormValues);
    const data = {
      title: questionName,
      type: 'boolean',
      question_content: tmpContent,
    };
    if (!hasErrors) {
      setLoading(true);
      actions.addNewQuestion(data).then(() => {
        setLoading(false);
        history.push('/egen-deklaration');
      }).catch(() => {
        setLoading(false);
        setError(true);
      });
    }
  };

  return (
    <div className='mt-3 flex h-full pb-8 px-6 flex-col overflow-y-scroll'>
      {loading && <UIModal message='Läser in...'/>}
      <div
        className='text-center py-1 rounded-7 text-xs bg-gray-200 w-20 mb-3 text-navy-primary'>
          Ja/Nej fråga
      </div>
      <UICardHeader
        title='Nytt fält'
        description={desc}
        longer={true}
        padding={false}
      />
      <div className='max-w-[600px]'>
        <UIStackedInput
          labelText='Namn på fält (detta är endast synligt för dig)'
          text={questionName}
          setText={setQuestionName}
          placeholder='exempel: Läkiningsprocess steg 1'
        />
        {questionErrors.questionName.length > 0 && (
          <span className='text-sm text-red-form'>{questionErrors.questionName}</span>
        )}
        {formValues.map((element, index) => (
          <OwnDeclarationAddInputs
            key={index}
            handleChange={handleChange}
            removeFormFields={removeFormFields}
            name={element.name}
            text={element.text}
            nameError={element.nameError}
            textError={element.textError}
            index={index}
          />
        ))}
        {/* {emptyFieldError && <div className='text-sm text-red-form mt-4'>Vänligen fyll i all information</div>} */}
        <button
          className='text-navy-primary text-xs font-bold underline pt-8 pb-4'
          type="button"
          onClick={() => addFormFields()}
        >
          Lägg till en fråga
        </button>
        <div className='flex justify-center md:justify-end pb-10 pt-5'>
          <UIButton type='full' style='round-10' onClick={onSubmit} text='Spara som färdig'/>
        </div>
        {error && <UIErrorIndicator />}
      </div>
    </div>
  );
};

export default AddBooleanQuestionPage;
